import {createContext} from 'react'

const RequerimientosCompraPendientesContext = createContext()

export default RequerimientosCompraPendientesContext